export const eventTeam = [
  { name: "Co Organizer", role: "co_event_organizer" },
  { name: "Event Host", role: "host" },
  { name: "Marketing", role: "event_org_marketing" },
  { name: "Sales", role: "event_org_sales" },
  { name: "Support Desk", role: "event_support_desk" },
  { name: "Session Host", role: "session_coordinator" },
  { name: "Security", role: "securityGuard" },
];
